/**
 * Maps each current-campaign poll party (`crosswalk.ts` key) to the name of
 * its closest analogue among the 2022 election results in
 * `$lib/data/election-data.json`, so a party's latest polling estimate can
 * be compared against what it actually won last time.
 *
 * Only parties with a clear, defensible 2022 lineage are mapped — `null`
 * marks a new party, a hypothetical/scenario column pollsters test (see the
 * note on the secondary tier in `crosswalk.ts`), or a party that would
 * double-count seats already attributed to another mapped party (e.g. Jewish
 * Power and Noam ran on Religious Zionism's 2022 list; United Arab List is
 * Ra'am's list name). Parties mapped to `null` still appear in the 2026
 * estimate (under their own poll-tracker label) — the mapping only controls
 * which 2022 bloc/colour a party inherits, not whether it's shown.
 *
 * NOT curated for the same reason `crosswalk.ts`'s secondary tier isn't —
 * review with an editor before publishing.
 */
export const pollPartyToElectionParty = {
  likud: 'Likud',
  united_torah_judaism: 'United Torah Judaism',
  shas: 'Shas',
  // Blue and White rebranded as National Unity ahead of the 2022 election.
  blue_and_white: 'National Unity Party',
  there_is_a_future: 'Yesh Atid',
  // Joint List keeps its own current label rather than mapping to a 2022
  // predecessor name (Hadash-Ta'al) — that mapping made the estimate row
  // display "Hadash-Ta'al" instead of "Joint List". Bloc colour for the bare
  // "Joint List" label is set directly in `party-meta.js`'s `arab` list.
  joint_list: null,
  israel_our_home: 'Yisrael Beitenu',
  // Keeps its own current label ("Democrats") rather than mapping to Labor
  // Party, its 2022 predecessor — that mapping made the estimate row display
  // "Labor Party" instead of "Democrats". Bloc colour for "Democrats" is set
  // directly in `party-meta.js`'s `left` list.
  democrats: null,
  religious_zionism_identity: 'Religious Zionism',
  raam: "Ra'am",
  jewish_power: null,
  together: null,
  yashar: null,
  reservists: null,
  // Same name as their 2022 lineage, so this is a no-op mapping — listed
  // for consistency with the rest of this file.
  hadash_taal: "Hadash-Ta'al",
  balad: 'Balad',
  erdan_edelstein_party: null,
  people_of_israel: null,
};
